import React, { useEffect, useState } from 'react';

import { EditOutlined, GlobalOutlined, HeartFilled, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Spin, Row, Col, Form, Input, message, Button, Modal, Popover } from 'antd';
import ApiErrorComp from '../ApiErrorComp/ApiErrorComp';
import liracrypt from '../Liracrypt/liracrypt';
import { debounce } from 'lodash';
import StAddNew from '../../pages/DSeries/StAddNew';

const TagBox = ({
    onTagAttach,
    params,
    tagList,
    setTagList
}) => {
    const [loading, setLoading] = useState(true);
    const [mergePopover, setMergePopover] = useState(false);
    const [tagsData, setTagsData] = useState();
    const [filteredTags, setFilteredTags] = useState([]);
    const [tagform] = Form.useForm();
    const [selectedTags, setSelectedTags] = useState([]);
    const [tagModal, setTagModal] = useState({
        open: false,
        data: null,
        typ: ''
    });
    const searchTag = debounce((value) => {
        setFilteredTags(tagsData.filter(x => x.label.toLowerCase().includes(value.toLowerCase())))
    }, 800);

    const getTags = () => {
        setLoading(true);
        liracrypt.get('pms/tag', { ...params, typ: 'PMS' })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setSelectedTags([]);
                    setTagsData(data.data);
                    setFilteredTags(data.data);
                    setLoading(false);
                } else {
                    message.error('Something went wrong');
                }
            }).catch(err => {
                ApiErrorComp();
                console.error(err);
            })
    }


    useEffect(() => {
        getTags();
    }, []);

    const tagClass = (tag) => {
        let isTagSelected = selectedTags.findIndex(x => x._id === tag._id);
        if (isTagSelected < 0) {
            return 'tag-label'
        } else {
            return 'tag-label selected'
        }
    }

    const handleClick = (tag, e) => {
        if (e.ctrlKey || e.metaKey) {
            if (selectedTags.includes(tag)) {
                setSelectedTags(selectedTags.filter(x => x.label !== tag.label));
            } else {
                setSelectedTags([tag, ...selectedTags]);
            }
        } else {
            if (e.detail === 2) {
                let selectedTag = tagList.find(x => x._id === tag._id);
                if (!selectedTag) {
                    setTagList([...tagList, tag]);
                }
            }
        }
    };

    const mergeTags = () => {
        liracrypt.post('/test', { ...params, tags: selectedTags })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setMergePopover(false);
                    message.success(data.message || 'Merged Successfully');
                    getTags();
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                console.log(err);
                ApiErrorComp();

            })
    }

    const togglePopover = (e) => {
        if (e) {
            if (selectedTags.length <= 0) {
                return
            };
            setMergePopover(e);
        }
    };

    const addNewTag = (values) => {
        let tagIndex = tagsData.findIndex(x => x.label.toLowerCase() === values.label.toLowerCase());
        if (tagIndex >= 0) {
            return message.error('Tag Already Exists');
        }
        liracrypt.post('/tag', { ...params, ...values })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setTagModal({
                        open: false,
                        typ: '',
                        data: null
                    })
                    message.success(data.message || 'Added Successfully');
                    getTags();
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                console.log(err);
                ApiErrorComp();

            })
    }

    return (
        <div>
            {
                loading ?
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} />} />
                    </div> :
                    <div>
                        <div className={'customer-complaint'} style={{ padding: "10px" }}>
                            <div className="customer-form">
                                <Form
                                    name="ReportForm"
                                    labelWrap={true}
                                    labelCol={{ span: 8 }}
                                    layout={"horizontal"}
                                    colon={false}
                                    onFinish={(values) => { console.log(values) }}
                                    size="large"
                                >
                                    <Row justify={"center"}>
                                        <Col span={22}>
                                            <Form.Item name="tagSearch">
                                                <Input onChange={(e) => searchTag(e.target.value)} placeholder='Search' type="search" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={2}>
                                            <Button
                                                onClick={() => {
                                                    setTagModal({
                                                        open: true,
                                                        data: null,
                                                        typ: 'add-tag'
                                                    })
                                                }}
                                                type='primary'
                                                icon={
                                                    <PlusOutlined />
                                                }>{''}</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>

                        <div>
                            <Popover
                                placement='bottom'
                                onOpenChange={(e) => togglePopover(e)}
                                content={<Button type="ghost" onClick={mergeTags}>Merge {selectedTags.length} Tags</Button>}
                                trigger="contextMenu"
                                open={mergePopover}
                            >
                                <div className='scroller' style={{ padding: 10 }}>
                                    {
                                        filteredTags.map((tag, index) => (
                                            <div
                                                onClick={(e) => handleClick(tag, e)}
                                                className={tagClass(tag)} style={{ display: 'inline-flex', color: '#ffffff', fontSize: 12, padding: '5px 10px 5px 10px', backgroundColor: tag.colr, alignItems: 'center', borderRadius: 10, margin: 10 }} key={index} color={tag.colr}>
                                                <div style={{ marginRight: 10 }}>
                                                    {
                                                        tag.fav && (
                                                            <HeartFilled color='red' size={20} />
                                                        )
                                                    }
                                                    {
                                                        tag.local && (
                                                            <EditOutlined color='red' size={20} />
                                                        )
                                                    }
                                                    {
                                                        tag.global && (
                                                            <GlobalOutlined color='red' size={20} />
                                                        )
                                                    }
                                                </div>
                                                <p style={{ marginBottom: 0, userSelect: 'none' }}>{tag.label}</p>
                                            </div>
                                        ))
                                    }
                                </div>
                            </Popover>
                            <div style={{ width: '100%', textAlign: 'center' }}>
                                <Button onClick={() => setTagList(selectedTags)} htmlType="button" type='primary'>Submit</Button>
                            </div>
                        </div>
                    </div>
            }
            {
                tagModal.open ?
                    <Modal maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={tagModal.open} title={"Add Tag"} onCancel={() => {
                        setTagModal({
                            open: false,
                            typ: '',
                            data: null
                        })
                    }}>
                        <>
                            <StAddNew
                                urlMethod={"POST"}
                                formName="AddTagForm"
                                setSmodalTitle={title => { console.log(title) }}
                                initForm={tagform}
                                colSpan={24}
                                urlEndpoint={'/smodal/zenform'}
                                urlData={{ ...params, dictName: 'Pms_tagForm' }}
                                onFormSubmit={addNewTag}
                            />
                            <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                                <Button loading={false} htmlType='submit' type="primary" form={'AddTagForm'}>Submit</Button>
                            </div>
                        </>
                    </Modal> : <></>
            }

        </div>
    )
};

export default TagBox;